import { Select } from "antd";

// Props:
//   value        array de valores seleccionados
//   onChange(arr)
//   options      [{ value, label }]
//   placeholder, disabled, className
export default function TagsMultiSelect({
  value = [],
  onChange,
  options = [],
  placeholder = "Selecciona...",
  disabled,
  className = "",
}) {
  return (
    <Select
      mode="multiple"
      value={value}
      onChange={onChange}
      options={options}
      placeholder={placeholder}
      disabled={disabled}
      className={className}
      style={{ width: "100%" }}
      optionFilterProp="label"
      allowClear
    />
  );
}
